export default function UnitFigure({ label, value }: { label: string; value: string }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 96 }}>
      <span className="muted" style={{ fontSize: 11.5 }}>{label}</span>
      <span className="tnum" style={{ fontSize: 13 }}>{value}</span>
    </div>
  );
}
